module.exports = "<a href=\"#\" ng-click=\"$ctrl.openModal()\" class=\"{{$ctrl.class}}\"><i ng-if=\"$ctrl.icon\" class=\"fa fa-fw fa-{{$ctrl.icon}}\"></i>{{$ctrl.text}}</a>"


//////////////////
// WEBPACK FOOTER
// ./client/components/eform-link/eform-link.component.html
// module id = 722
// module chunks = 0